import React, { useEffect, useRef, useState } from "react";
import { DataVisualizer, DataItem } from "layouts";
import { PlusIcon } from "@heroicons/react/24/solid";
import {
  getDatabase,
  ref as dbRef,
  set,
  onValue,
  push,
  get,
} from "firebase/database";
import { database, storage } from "../../../../firebase";
import { ref as strgRef, getStream, getBlob, getBytes } from "firebase/storage";
import { DeleteModal, FileVisualizer } from "features/projects";
import {
  checkFileExtension,
  getStatus,
  handleDeleteProject,
  uploadFile,
  uploadFilePromise,
} from "features/projects/actions";
import { toast } from "react-toastify";
import { getAnalysisResults } from "features/projects/actions/getAnalysisResults";
import { FailButton, NextButton, SuccessButton } from "components/buttons";
import Lottie from "lottie-react";
import loadingAnimationData from "../../../../assets/lotties/searchingLoadingAnim.json";
import successAnimationData from "../../../../assets/lotties/successAnim.json";
import errorAnimationData from "../../../../assets/lotties/errorAnim.json";
import { gql, useMutation } from "@apollo/client";
import { getAuth } from "@firebase/auth";
import JSZip from "jszip";
import { makeGraphData } from "../graphs/GraphDataProcess";
import { colorsForNames } from "../graphs/GraphColors";
import { Spinner } from "flowbite-react";
import { ProjectDetailsHelp } from "../helpPages";

// Define mutation
const CREATE_TICKET = gql`
  mutation CreateTicket($token: String, $fileurl: String, $fireuser: String) {
    createTicket(
      coupticket: { token: $token, fileurl: $fileurl, fireuser: $fireuser }
    ) {
      m
      couptype {
        couptimestamp
        coupfileurl
        filechecksum
        dpcrvendor
        coupresultjson
      }
    }
  }
`;

export const ProjectDetails = ({ projectID }) => {
  const db = getDatabase();
  const projectRef = dbRef(db, `projects/${projectID}`);
  const [projectData, setProjectData] = useState();
  const [analysisResultMessage, setAnalysisResultMessage] = useState("");

  const customTheme = {
    color: {
      info: 'fill-blue-700',
    },
  };

  //console.log(projectData);

  useEffect(() => {
    onValue(projectRef, (snapshot) => {
      let data = snapshot.val();
      if (data && data.details && data.main) {
        if (data.details.sampleDefFile !== "") {
          data.details.sampleDefFilename = strgRef(
            storage,
            data.details.sampleDefFile
          ).name;
        }
        if (data.details.dataFiles) {
          data.details.dataFilenames = Object.values(
            data.details.dataFiles
          ).map((file) => strgRef(storage, file).name);
        }
        data.main.status = getStatus(data);
      }
      setProjectData(data);
    });
    //console.log("ProjectData");
  }, []);

  //console.log(projectData);

  //console.log("RENDER");

  const [addPercent, setAddPercent] = useState([]);
  const [totalAddPercent, setTotalAddPercent] = useState(0);
  const [samplePercent, setSamplePercent] = useState(0);

  const auth = getAuth();
  var [accessToken, setAccessToken] = useState();

  useEffect(() => {
    if (auth.currentUser) {
      auth.currentUser
        .getIdToken(true)
        .then(function (idToken) {
          setAccessToken(idToken);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    //console.log("Auth");
  }, [auth.currentUser]);

  const [createTicket, { data, loading, error }] = useMutation(CREATE_TICKET);

  const dataRef = useRef(null);
  dataRef.current = data;

  const errorRef = useRef();
  dataRef.current = error;

  //console.log("DATA", data);
  const resultData = data;

  function isLoading() {
    return projectData.main.status === 4;
  }

  function isError() {
    return projectData.main.status === 5;
  }

  function handleAddSampleDefFile(event) {
    const newFile = event.target.files[0];
    if (!checkFileExtension(newFile)) {
      toast.error(`File extension is not suported!`, {
        position: "top-center",
      });
      return;
    }
    const storageRef = strgRef(storage, `/files/${projectID}/${newFile.name}`);
    uploadFile(
      newFile,
      storageRef,
      (newData) => {
        set(
          dbRef(database, "projects/" + projectID + "/details/sampleDefFile"),
          newData
        );
      },
      setSamplePercent
    );
  }

  useEffect(() => {
    let temp = 0;
    let len = 0;
    addPercent.forEach(element => {
      temp += element;
      len += 1;
    });
    if (len) {
      const tp = temp / len;
      setTotalAddPercent(tp);
    }
  }, [addPercent]);

  useEffect(() => {
    if (totalAddPercent === 100) {
      setTotalAddPercent(0)
      setAddPercent((prev) =>
        []);
    }
  }, [totalAddPercent])


  const updatePercent = (p, idx) => {
    setAddPercent((prev) =>
      Object.assign([], {
        ...prev,
        [idx]: p,
      }));
  }

  function handleAddDataFile(event) {
    const dataFiles = event.target.files
    if (dataFiles.length > 5 - (projectData.details?.dataFilenames?.length ? projectData.details?.dataFilenames?.length : 0)) {
      toast.error("Uploada total of 5 files maximum!", {
        position: "top-center",
      });
      return;
    }
    for (let i = 0; i < dataFiles.length; i++) {
      //console.log("check extensions pelase")
      if (!checkFileExtension(dataFiles[i])) {
        //console.log("yay");
        toast.error(`${dataFiles[i].name}'s extension is not supported!`, {
          position: "top-center",
        });
        return;
      }
      updatePercent(0, i);
      let file = dataFiles[i];
      const storageRef = strgRef(
        storage,
        `/files/${projectID}/${file.name}`
      );
      uploadFile(
        file,
        storageRef,
        (newData) => {
          set(
            push(
              dbRef(
                database,
                "projects/" +
                projectID +
                "/details/dataFiles"
              )
            ),
            newData
          );
        },
        updatePercent,
        i
      );
    }
    deleteResults();
  }

  function makeRequest(method, type, url) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.responseType = type;
      xhr.open(method, url);
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.response);
        } else {
          reject({
            status: xhr.status,
            statusText: xhr.statusText,
          });
        }
      };
      xhr.onerror = function () {
        reject({
          status: xhr.status,
          statusText: xhr.statusText,
        });
      };
      xhr.send();
    });
  }

  function zipAndSaveFiles() {
    //console.log("Zipping...");
    return new Promise(async (resolve, reject) => {
      try {
        const sampleDefFileRef = projectData.details.sampleDefFile;
        const dataFilesRef = Object.values(projectData.details.dataFiles);

        //console.log('sampleDefFile', sampleDefFileRef);
        //console.log('dataFiles', dataFilesRef);

        const zipURLsArray = [sampleDefFileRef, ...dataFilesRef];
        const fileNames = zipURLsArray.map((url) => strgRef(storage, url).name);

        const jszip = new JSZip();

        const promises = zipURLsArray.map((url) =>
          makeRequest("GET", "blob", url)
        );

        Promise.all(promises).then(async (responses) => {
          responses.forEach((response, index) => {
            jszip.file(fileNames[index], response);
          });
          const zippedFiles = await jszip.generateAsync({
            type: "blob",
          });

          const storageRef = strgRef(
            storage,
            `/files/${projectID}/zippedFiles.zip`
          );

          const url = await uploadFilePromise(
            zippedFiles,
            storageRef,
            (newData) => {
              set(
                dbRef(
                  database,
                  "projects/" + projectID + "/details/zippedFiles"
                ),
                newData
              );
            }
          );
          //console.log(url);
          //console.log("READY");
          resolve(url);
        });
      } catch (error) {
        console.log("Zipping error:", error);
        reject(error);
      }
    });
  }

  const timer = (ms) => new Promise((res) => setTimeout(res, ms));

  async function handleCalculate() {
		//set project status to loading
		set(dbRef(database, "projects/" + projectID + "/main/status"), 4);

		 // zip files and save zip to storage
		const zipURL = await zipAndSaveFiles();

		//console.log(res);

		// call graphql mutation
		const uid = auth.currentUser.uid;
		const token = projectData.details.token;

		const params = {
			variables: {
				token: token,
				fileurl: zipURL,
				fireuser: uid,
			},
			context: {
				headers: {
					authorization: "Bearer " + accessToken,
				},
			},
		};
		//console.log("PARAMS", params);

		//console.log("Hello");

		const res = await getAnalysisResults(createTicket, params);
        setAnalysisResultMessage(res.message);

		//const res = "[{\"samplegroup\": 1, \"coloring\": 1, \"samplename\": \"NTC\", \"colors\": [{\"antibodyleft\": \"PTZ\", \"antibodyright\": \"TTZ\", \"colorpair\": \"GY\", \"values\": {\"zero\": [25172], \"left\": [6], \"include\": [true], \"right\": [5], \"couplex\": [0], \"rightlambda\": [0], \"well\": [\"A1\"], \"duplex\": [0], \"theoretical\": [0], \"leftlambda\": [0]}}], \"included\": true, \"abc\": false}, {\"samplegroup\": 2, \"coloring\": 2, \"samplename\": \"Diution 2\", \"colors\": [{\"antibodyleft\": \"PTZ\", \"antibodyright\": \"TTZ\", \"colorpair\": \"GY\", \"values\": {\"zero\": [17627, 18575, 17808, 19677], \"left\": [4043, 3588, 4205, 3188], \"include\": [true, true, true, true], \"right\": [2595, 2348, 2423, 2037], \"couplex\": [773, 682, 640, 415], \"rightlambda\": [152, 132, 139, 106], \"well\": [\"A2\", \"B2\", \"C2\", \"D2\"], \"duplex\": [955, 772, 871, 525], \"theoretical\": [704, 538, 661, 374], \"leftlambda\": [221, 189, 224, 158]}}], \"included\": true, \"abc\": false}, {\"samplegroup\": 2, \"coloring\": 2, \"samplename\": \"Diution 4\", \"colors\": [{\"antibodyleft\": \"PTZ\", \"antibodyright\": \"TTZ\", \"colorpair\": \"GY\", \"values\": {\"zero\": [17773, 17921, 18527, 18455], \"left\": [3969, 4089, 3746, 3852], \"include\": [true, true, true, true], \"right\": [2631, 2678, 2507, 2504], \"couplex\": [166, 161, 130, 100], \"rightlambda\": [141, 142, 129, 129], \"well\": [\"A3\", \"B3\", \"C3\", \"D3\"], \"duplex\": [664, 687, 568, 570], \"theoretical\": [610, 633, 523, 536], \"leftlambda\": [205, 209, 187, 191]}}], \"included\": true, \"abc\": false}, {\"samplegroup\": 2, \"coloring\": 2, \"samplename\": \"ABC\", \"colors\": [{\"antibodyleft\": \"PTZ\", \"antibodyright\": \"TTZ\", \"colorpair\": \"GY\", \"values\": {\"zero\": [21046, 20281, 22786], \"left\": [2514, 2251, 1446], \"include\": [true, true, true], \"right\": [1608, 1510, 1117], \"couplex\": [-47, -31, 19], \"rightlambda\": [73, 71, 48], \"well\": [\"B1\", \"C1\", \"D1\"], \"duplex\": [170, 154, 80], \"theoretical\": [188, 165, 72], \"leftlambda\": [112, 105, 62]}}], \"included\": true, \"abc\": true}, {\"samplegroup\": 2, \"coloring\": 2, \"samplename\": \"Diution 1\", \"colors\": [{\"antibodyleft\": \"PTZ\", \"antibodyright\": \"TTZ\", \"colorpair\": \"GY\", \"values\": {\"zero\": [20951, 20767, 20238, 20942], \"left\": [2628, 2756, 2983, 2590], \"include\": [true, true, true, true], \"right\": [1611, 1616, 1800, 1552], \"couplex\": [188, 165, 208, 227], \"rightlambda\": [78, 78, 89, 76], \"well\": [\"E1\", \"F1\", \"G1\", \"H1\"], \"duplex\": [291, 292, 363, 299], \"theoretical\": [218, 229, 285, 211], \"leftlambda\": [122, 128, 141, 121]}}], \"included\": true, \"abc\": false}, {\"samplegroup\": 2, \"coloring\": 2, \"samplename\": \"Diution 3\", \"colors\": [{\"antibodyleft\": \"PTZ\", \"antibodyright\": \"TTZ\", \"colorpair\": \"GY\", \"values\": {\"zero\": [18029, 18052, 18236, 18481], \"left\": [4099, 4078, 3865, 3749], \"include\": [true, true, true, true], \"right\": [2585, 2562, 2530, 2486], \"couplex\": [185, 307, 325, 405], \"rightlambda\": [137, 138, 136, 134], \"well\": [\"E2\", \"F2\", \"G2\", \"H2\"], \"duplex\": [675, 723, 689, 695], \"theoretical\": [613, 621, 579, 556], \"leftlambda\": [208, 209, 198, 192]}}], \"included\": true, \"abc\": false}, {\"samplegroup\": 2, \"coloring\": 2, \"samplename\": \"Diution 5\", \"colors\": [{\"antibodyleft\": \"PTZ\", \"antibodyright\": \"TTZ\", \"colorpair\": \"GY\", \"values\": {\"zero\": [19372, 17728, 17833, 17556], \"left\": [3356, 4253, 4024, 4238], \"include\": [true, true, true, true], \"right\": [2267, 2724, 2882, 2726], \"couplex\": [-15, -70, -23, 43], \"rightlambda\": [110, 142, 149, 145], \"well\": [\"E3\", \"F3\", \"G3\", \"H3\"], \"duplex\": [386, 620, 639, 678], \"theoretical\": [391, 643, 647, 664], \"leftlambda\": [160, 214, 203, 217]}}], \"included\": true, \"abc\": false}]";

		if (res.code === 1) {
			// handle errors
			console.log("ERROR", errorRef.current);
			set(dbRef(database, "projects/" + projectID + "/main/status"), 5);
		} else if (res.code === 2) {
			// handle timeout
			//console.log("TIMEOUT");
			set(dbRef(database, "projects/" + projectID + "/main/status"), 5);
		} else {
			const result = res.message;
			//console.log("1. RESULT", result);
			//console.log("MOCK RESULT", mockRes);
			//const result = res;
			const parse1 = JSON.parse(JSON.parse(result));
			//console.log("2. PARSE1", parse1);
			const parse2 = JSON.stringify(parse1);
			//console.log("3. PARSE2", parse2);
			const parse3 = JSON.parse(parse2);
			//console.log("4. PARSE3", parse3);
			// const parsedData = [...JSON.parse(JSON.stringify(JSON.parse(result)))];
			//console.log("PARSED", parse3);
			const graphData = makeGraphData(parse3);
			let graphs = [];
			graphData.forEach((graph, key) => {
				// let newgraph = graph.map((sample, index) => {
				// 	return {
				// 		...sample,
				// 		// plotColor: {
				// 		// 	light: colorsForNames.light[index],
				// 		// 	dark: colorsForNames.dark[index],
				// 		// }
				// 	};
				// });
				graphs.push(graph);
			});
			//console.log("GRAPHS", graphs);
			set(
				dbRef(database, "projects/" + projectID + "/result/data"),
				graphs
			);
			set(
				dbRef(database, "projects/" + projectID + "/result/length"),
				graphs.length
			);
			set(dbRef(database, "projects/" + projectID + "/main/status"), 6);
		}
	}

    // async function handleCalculate() {
	// 	set(
	// 		dbRef(database, "projects/" + projectID + "/main/status"),
	// 		4
	// 	);
	// 	getAnalysisResults().then((result) => {
    //         set(dbRef(database, "projects/" + projectID + "/main/status"), 6);
	// 		set(
	// 			dbRef(database, "projects/" + projectID + "/result/data"),
	// 			result
	// 		);
	// 		set(
	// 			dbRef(database, "projects/" + projectID + "/result/length"),
	// 			result.length
	// 		);
	// 		set(
	// 			dbRef(database, "projects/" + projectID + "/main/result"),
	// 			"done"
	// 		);
	// 	});
	// }

	const deleteResults = async () => {
		set(dbRef(database, "projects/" + projectID + "/result"), null);
		set(dbRef(database, "projects/" + projectID + "/main/status"), 0);
	};

  return projectData ? (
    <>
      <DataVisualizer
        header={"Project data"}
        tips={<ProjectDetailsHelp />}
      >
        <DataItem label="Creation date, time:">
          {projectData.details.date}
        </DataItem>
        <DataItem label="Creator:">{projectData.details.creatorName}</DataItem>
        <DataItem label="Sample definition file:">
          {projectData.details.sampleDefFile ? (
            <FileVisualizer
              fileURL={projectData.details.sampleDefFile}
              dataRef={dbRef(
                database,
                "projects/" + projectID + "/details/sampleDefFile"
              )}
              onFileChange={deleteResults}
            />
          ) : (
            <div className="flex pb-1">
              <label className="flex p-3 items-center py-2 px-4 shadow-md border border-blue-700 text-blue-700 bg-blue-50 cursor-pointer rounded-full hover:bg-blue-100">
                {!samplePercent ? <PlusIcon className="w-5 h-5" /> : <Spinner color="info" size="sm" theme={customTheme} />}
                <p className="pl-2 text-sm font-bold">{samplePercent ? "Uploading..." : "Add file"}</p>
                <input
                  id="dropzone-file"
                  data-testid="add-sample-file"
                  onChange={handleAddSampleDefFile}
                  type="file"
                  accept=".xls,.xlsx,.csv"
                  className="hidden"
                  disabled={samplePercent}
                />
              </label>
              {samplePercent > 0 && (
                <div
                  className="radial-progress text-blue-600 mx-5 my-2"
                  style={{
                    "--value": samplePercent,
                    "--size": "2rem",
                    "--thickness": "4px",
                  }}
                ></div>
              )}
            </div>
          )}
        </DataItem>
        <DataItem label="Raw data files:">
          <dl className="divide-y divide-gray-200">
            {projectData.details.dataFiles &&
              Object.entries(projectData.details.dataFiles).map(
                ([key, file], index) => {
                  return (
                    <div className="py-2" key={index}>
                      <FileVisualizer
                        key={key}
                        fileURL={file}
                        dataRef={dbRef(
                          database,
                          "projects/" + projectID + "/details/dataFiles/" + key
                        )}
                        onFileChange={deleteResults}
                      />
                    </div>
                  );
                }
              )}
          </dl>
          {projectData.details.dataFiles && <hr />}
          {(!projectData.details.dataFiles ||
            projectData.details.dataFilenames.length < 5) && (
              <div className="flex py-2">
                <label className="flex p-3 items-center py-2 px-4 shadow-md border border-blue-700 text-blue-700 bg-blue-50 cursor-pointer rounded-full hover:bg-blue-100">
                  {!totalAddPercent ? <PlusIcon className="w-5 h-5" /> : <Spinner color="info" size="sm" theme={customTheme} />}
                  <p className="pl-2 text-sm font-bold">
                    {totalAddPercent > 0 ? "Uploading..." : "Add files"}
                  </p>
                  <input
                    id="dropzone-file"
                    data-testid="add-data-file"
                    onChange={handleAddDataFile}
                    type="file"
                    accept=".xls,.xlsx,.csv"
                    className="hidden"
                    multiple
                    disabled={totalAddPercent}
                  />
                </label>
                {totalAddPercent > 0 && (
                  <div
                    className="radial-progress text-blue-600 mx-5 my-2"
                    style={{
                      "--value": totalAddPercent,
                      "--size": "2rem",
                      "--thickness": "4px",
                    }}
                  ></div>
                )}
              </div>
            )}
        </DataItem>
      </DataVisualizer>
      {projectData.main.status <= 3 ? (
        <div
          data-testid={`ProjectDetails-result-status-${projectData.main.status}`}
          className={`bg-gray mt-6 p-6 bg-opacity-20 rounded-medium ${projectData.main.status == 3 ? "bg-blue-500" : "bg-other-red"
            }`}
        >
          <div className="mb-6 text-custom">
            <h1 className="text-lg font-bold">
              {projectData.main.status === 3
                ? "Run your analysis!"
                : "Upload data to proceed!"}
            </h1>
            <p className="text-sm">
              {projectData.main.status === 3
                ? "Click the button below to initiate the data analysis."
                : "You must upload a sample definition file and at least one raw data file."}
            </p>
          </div>
          <NextButton
            onClick={handleCalculate}
            disabled={projectData.main.status == 3 ? false : true}
          >
            Calculate results
          </NextButton>
        </div>
      ) : isLoading() ? (
        <div
          data-testid={`ProjectDetails-result-status-${projectData.main.status}`}
          className="bg-gray mt-6 px-2 bg-opacity-20 rounded-medium flex flex-row items-center bg-primary-orange"
        >
          <div className="h-[100px] w-[100px] flex-shrink-0">
            <Lottie
              data-testid="ProjectDetails-result-loading"
              animationData={loadingAnimationData}
            />
          </div>
          <div className="text-custom">
            <h1 className="text-lg font-bold">Generating graphs...</h1>
            <p className="text-sm">This should only take a couple minutes.</p>
          </div>
        </div>
      ) : (
        <div
          data-testid={`ProjectDetails-result-status-${projectData.main.status}`}
          className={`bg-gray mt-6 px-2 bg-opacity-20 rounded-medium flex flex-row items-center ${isError() ? " bg-other-red" : "bg-other-green"
            }`}
        >
          <div className="h-[100px] w-[100px] flex-shrink-0 p-4">
            {isError() ? (
              <Lottie
                data-testid="ProjectDetails-result-error"
                animationData={errorAnimationData}
                loop={false}
              />
            ) : (
              <Lottie
                data-testid="ProjectDetails-result-done"
                animationData={successAnimationData}
                loop={false}
              />
            )}
          </div>
          <div className="text-custom">
            <h1 className="text-lg font-bold">
              {isError() ? "An error occured!" : "Results are ready!"}
            </h1>
            <p className="text-sm">
              {isError()
                ? analysisResultMessage
                : "You can access your graphs by cliking the 'Results' button on your dashboard."}
            </p>
          </div>
        </div>
      )}
    </>
  ) : (
    /**
     * SKELETON
     */
    <>
      <DataVisualizer
        header={"Project data"}
      >
        <div
          data-testid="loading"
          className="grid grid-cols-1 gap-3 sm:grid-cols-3 py-7 w-full animate-pulse opacity-40"
        >
          <div className="bg-gray-200 h-4 sm:h-6 rounded-full mr-24"></div>
          <div className="bg-gray-200 h-4 sm:h-6 rounded-full mr-32"></div>
        </div>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 py-7 w-full animate-pulse opacity-40">
          <div className="bg-gray-200 h-4 sm:h-6 rounded-full mr-24"></div>
          <div className="bg-gray-200 h-4 sm:h-6 rounded-full mr-32"></div>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 w-full py-8 animate-pulse opacity-40">
          <div className="bg-gray-200 h-4 sm:h-6 rounded-full mr-24"></div>
          <div className="sm:hidden"></div>
          <div className="bg-gray-200 h-6 sm:h-8 w-44 rounded-full"></div>
          <div className="flex flex-row gap-5">
            <div className="rounded-full sm:h-8 sm:w-8 h-6 w-6 bg-gray-200"></div>
            <div className="rounded-full sm:h-8 sm:w-8 h-6 w-6 bg-gray-200"></div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 w-full py-8 animate-pulse opacity-40">
          <div className="bg-gray-200 h-4 sm:h-6 rounded-full mr-24"></div>
          <div className="sm:hidden"></div>
          <div className="bg-gray-200 h-6 sm:h-8 w-44 rounded-full"></div>
          <div className="flex flex-row gap-5">
            <div className="rounded-full sm:h-8 sm:w-8 h-6 w-6 bg-gray-200"></div>
            <div className="rounded-full sm:h-8 sm:w-8 h-6 w-6 bg-gray-200"></div>
          </div>
        </div>
      </DataVisualizer>
      <div className="h-[100px] w-full bg-gray-200 rounded-medium mt-20 animate-pulse opacity-40"></div>
    </>
  );
};
